import { bearerAuth } from "../standardAuthPatterns";
import logo from "../trendMicro/logo.svg";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";

export const trendVisionOne = defineConnector({
  identifier: "trendVisionOne",
  name: "Trend Vision One",
  tagLine: "Extended detection and response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ apiHost }) =>
    urlToPattern(
      apiHost,
      "https://api(?:\\.[a-z]+)?\\.xdr\\.trendmicro\\.(com|co\\.jp)/.*"
    ),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a Trend Vision One API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Trend Vision One, go to **Administration > API Keys**, create a new API key, and copy the authentication token.",
        },
      ],
    },
    {
      title: "Enter your Trend Vision One details",
      items: [
        {
          kind: "url",
          label: "Regional API host",
          required: true,
          defaultValue: "https://api.xdr.trendmicro.com",
          placeholder: "https://api.xdr.trendmicro.com",
          target: { kind: "configuration", field: "apiHost" },
          helperText:
            "Use the regional Trend Vision One API host for your tenant, for example `https://api.xdr.trendmicro.com` or `https://api.eu.xdr.trendmicro.com`.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiHost }) =>
      `${apiHost || "https://api.xdr.trendmicro.com"}/v3.0/threatintel/suspiciousObjectExceptions`,
  },
});
